import React from 'react';
import cn from 'classnames';

import { Tooltip } from '@components/common';

import { Icons } from '@icons/icons';

import { ISelectValueProps } from './SelectValue.types';

import './SelectValue.scss';

const SelectValue: React.FC<ISelectValueProps> = ({
	option,
	removeHandler,
	isOverflow,
	selectItemRef,
	readOnly,
	isDisabled,
}) => {
	const removeOption = () => {
		if (option.id && removeHandler) {
			removeHandler([option.id], [option.categoryName as string]);
		}
	};

	const wrapperClassName = cn('f5gSelectItemContainer', {
		'f5gSelectItemContainerDisabled': isDisabled,
	});

	return (
		<Tooltip
			content={option.title}
			isDisabled={!isOverflow}
			placement='top'
		>
			<div
				ref={selectItemRef}
				className={wrapperClassName}
				style={{ overflow: isOverflow ? 'hidden' : 'visible' }}
			>
				<div
					className='f5gSelectItemTitle'
					data-testid='select-item-title'
				>
					{option.title}
				</div>
				{!readOnly && <div
					className='f5gSelectItemClearIcon'
					onClick={removeOption}
				>
					{Icons.clearGroupSelect()}
				</div>
				}
			</div>
		</Tooltip>
	);
};

export default SelectValue;
